<template>
  <div class="wechatAccount">
    <div class="prompt">
      {{$t('channel.wechatAccount.prompt')}}
    </div>
    <div class="wechatAccountContainer">
      <template v-if="!isAuthorization">
        <img src="../../../../assets/images/unauthorized.png">
        <div class="unauthorizedTip">
          {{$t('channel.wechatAccount.unAuth')}}
        </div>
        <div class="tips">
          <span>{{$t('channel.wechatAccount.authTip1')}}</span>
          <div class="authorization" @click="authorization">
            {{$t('channel.wechatAccount.btnText')}}
          </div>
        </div>
      </template>
      <template v-else>
        <img src="../../../../assets/images/authorize.png">
        <div class="authorizedTip">
          已成功授权公众号：{{bindDetail.agentName}}
        </div>
      </template>
    </div>

  </div>
</template>

<script>
export default {
  name: "basicInformation",
  data(){
    return{
      isAuthorization:false,
      loop:null
    }
  },
  props:{
    bindDetail:{
      type:Object,
      default(){
        return {}
      }
    }
  },
  methods:{
    authorization(){
      let currentUrl = process.env.VUE_APP_OPEN_HOST;
      console.log('currentUrl',currentUrl,process.env);
      if (currentUrl.indexOf("tabIndex") == -1) {
        currentUrl += "?tabIndex=bot-access";
      }
      if (currentUrl.indexOf("bindType") == -1) {
        currentUrl += "&bindType=mp";
      }
      console.log("get redirect url:", currentUrl);
      let params = {
        bindType: 0,
        currentUrl: currentUrl,
        authType: 1, //1:公众号 2：小程序 3：公众号和小程序
      }
      this.$http.get(this.requestUrl.wechatBind.newWechatBind, {
        params: params,
        data: params
      }).then((res) => {
        if (res.data.code === "0") {
          if (res.data.data) {
            location.href = res.data.data;
            // let w = window.open(
            //     res.data.data,
            //     "newwindow",
            //     "height=500, width=800, top=200, left=400, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no"
            // );
            // this.loop = setInterval(function () {
            //   if (w != null && w.closed) {
            //     clearInterval(this.loop);
            //     //do something 在这里执行回调
            //     this.isAuthorization = true;
            //     this.$emit('authorizationSuccess')
            //   }
            // }, 800);
          }
        } else {
          this.$message.error(this.$t('channel.bindError'));
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.wechatAccount{
  height: 100%;
  .prompt{
    background: #FFF8F4;
    border-radius: 5px;
    border: 1px solid #FFD9C5;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #FF9555;
  }
  .wechatAccountContainer{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100% - 60px);
    .unauthorizedTip{
      color: #616161;
      font-size: 18px;
      font-weight: bold;
      margin: 20px 0;
    }
    .authorizedTip{
      color: #616161;
      font-size: 18px;
      font-weight: bold;
      margin-top: 20px;
    }
    .tips{
      display: flex;
      align-items: center;
      color: #616161;
      .authorization{
        margin-left: 6px;
        cursor: pointer;
        color: #366aff;
      }
    }
  }
}
</style>